import { render } from "./ModalIdle.vue?vue&type=template&id=28128f42&scoped=true"
import script from "./ModalIdle.vue?vue&type=script&lang=js"
export * from "./ModalIdle.vue?vue&type=script&lang=js"

import "./ModalIdle.vue?vue&type=style&index=0&id=28128f42&lang=postcss&scoped=true"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28128f42"]])

export default __exports__